import styled, { css } from 'styled-components';
import { em,rem } from 'polished';
import { HeadingBase } from 'elements/Heading/styled';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const StyldedFileUpload = styled.input`
  
  &.error {
    outline-color: ${colors.ERROR} !important;
    outline-width: 2px;
    outline-offset: 2px;
    outline-style: solid;
  }


`;
export const StyldedTextInput = styled.input`
  
  &.error {
    outline-color: ${colors.ERROR} !important;
    outline-width: 2px;
    outline-offset: 2px;
    outline-style: solid;
  }


`;
export const StyldedTextArea = styled.textarea`
  
  &.error {
    outline-color: ${colors.ERROR} !important;
    outline-width: 2px;
    outline-offset: 2px;
    outline-style: solid;
  }


`;

export const StyldedError = styled.span`
  display:block;
  margin-top:${rem(8)};
  font-size:${rem(14)};
  color: ${colors.ERROR};


`;



// WEBPACK FOOTER //
// ./src/elements/Form/Input/styled.js